import React from 'react'
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { Card, CardBody, Col } from 'reactstrap';
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader';
import { PolylinesTitle } from '../../../../Utils/Constants';
import { containerStyle, defaultCenter } from '../../../../Data/Miscellaneous/Maps';

export default function PolylineMaps() {
    const { isLoaded } = useJsApiLoader({
      id: "google-map-script",
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY!
    });
    return (
        <Col sm={6}>
            <Card>
                <CommonCardHeader title={PolylinesTitle} />
                <CardBody className='z-1'>
                    <div className="map-js-height">
                        <div id="gmap-simple" className="map-block">
                            {isLoaded ? <GoogleMap mapContainerStyle={containerStyle} center={defaultCenter} zoom={10}></GoogleMap> : "loading"}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}